// ============================================
// DONNÉES CENTRALISÉES POUR BRILLANTY
// Application de gestion des interventions de lavage de véhicules
// ============================================

// ============================================
// UTILISATEURS
// ============================================
export const users = [
  {
    id: 1,
    username: 'admin',
    password: 'admin123',
    nom: 'Saladino',
    prenom: 'Kévin',
    email: 'kevin.saladino@brillanty.fr',
    role: 'admin',
    telephone: '06 12 34 56 78',
  },
  {
    id: 2,
    username: 'tech1',
    password: 'tech123',
    nom: 'Martin',
    prenom: 'Lucas',
    email: 'lucas.martin@brillanty.fr',
    role: 'technicien',
    telephone: '06 23 45 67 89',
    centreId: 1,
  },
  {
    id: 3,
    username: 'tech2',
    password: 'tech123',
    nom: 'Bernard',
    prenom: 'Sophie',
    email: 'sophie.bernard@brillanty.fr',
    role: 'technicien',
    telephone: '06 34 56 78 90',
    centreId: 1,
  },
  {
    id: 4,
    username: 'tech3',
    password: 'tech123',
    nom: 'Dubois',
    prenom: 'Thomas',
    email: 'thomas.dubois@brillanty.fr',
    role: 'technicien',
    telephone: '06 45 67 89 01',
    centreId: 2,
  },
  {
    id: 5,
    username: 'tech4',
    password: 'tech123',
    nom: 'Laurent',
    prenom: 'Julie',
    email: 'julie.laurent@brillanty.fr',
    role: 'technicien',
    telephone: '06 56 78 90 12',
    centreId: 3,
  },
  {
    id: 6,
    username: 'tech5',
    password: 'tech123',
    nom: 'Simon',
    prenom: 'Pierre',
    email: 'pierre.simon@brillanty.fr',
    role: 'technicien',
    telephone: '06 67 89 01 23',
    centreId: 4,
  },
  {
    id: 7,
    username: 'tech6',
    password: 'tech123',
    nom: 'Roux',
    prenom: 'Emma',
    email: 'emma.roux@brillanty.fr',
    role: 'technicien',
    telephone: '06 78 90 12 34',
    centreId: 5,
  },
];

// ============================================
// CENTRES DE LAVAGE
// ============================================
export const centres = [
  {
    id: 1,
    nom: 'Centre Marseille',
    adresse: '15 rue de la République',
    codePostal: '13000',
    ville: 'Marseille',
    telephone: '04 97 00 00 00',
    email: 'marseille@brillanty.fr',
    coordonneesGPS: {
      latitude: 48.9356,
      longitude: 2.3539,
    },
    actif: true,
    dateCreation: '2023-01-15',
  },
  {
    id: 2,
    nom: 'Centre Saint Marcel',
    adresse: '42 avenue du Général Leclerc',
    codePostal: '94270',
    ville: 'Saint Marcel',
    telephone: '01 49 87 65 43',
    email: 'paris-sud@brillanty.fr',
    coordonneesGPS: {
      latitude: 48.8092,
      longitude: 2.3617,
    },
    actif: true,
    dateCreation: '2023-02-10',
  },
  {
    id: 3,
    nom: 'Centre La valentine',
    adresse: '8 boulevard des Bouvets',
    codePostal: '92000',
    ville: 'La Valentine',
    telephone: '04 97 00 00 00',
    email: 'la-valentine@brillanty.fr',
    coordonneesGPS: {
      latitude: 48.8921,
      longitude: 2.2069,
    },
    actif: true,
    dateCreation: '2023-03-20',
  },
  {
    id: 4,
    nom: 'Centre Rognac',
    adresse: '23 rue du Général Sarrail',
    codePostal: '94000',
    ville: 'Rognac',
    telephone: '04 97 00 00 00',
    email: 'rognac@brillanty.fr',
    coordonneesGPS: {
      latitude: 48.7906,
      longitude: 2.4555,
    },
    actif: true,
    dateCreation: '2023-04-05',
  },
  {
    id: 5,
    nom: 'Centre Salon de Provence',
    adresse: '12 rue de la République',
    codePostal: '78000',
    ville: 'Salon de Provence',
    telephone: '04 97 00 00 00',
    email: 'salon-de-provence@brillanty.fr',
    coordonneesGPS: {
      latitude: 48.8014,
      longitude: 2.1301,
    },
    actif: true,
    dateCreation: '2023-05-12',
  },
];

// ============================================
// TYPES D'INTERVENTION
// ============================================
export const typesIntervention = [
  {
    id: 1,
    code: 'VN',
    libelle: 'Véhicule Neuf',
    description: 'Lavage complet d\'un véhicule neuf',
    dureeEstimee: 90, // 1h30 en minutes
    couleur: '#10b981', // vert
    actif: true,
  },
  {
    id: 2,
    code: 'VO',
    libelle: 'Véhicule d\'Occasion',
    description: 'Lavage et remise en état d\'un véhicule d\'occasion',
    dureeEstimee: 180, // 3h en minutes
    couleur: '#3b82f6', // bleu
    actif: true,
  },
  {
    id: 3,
    code: 'VC',
    libelle: 'Véhicule Client',
    description: 'Lavage d\'un véhicule client',
    dureeEstimee: 15, // 15 minutes
    couleur: '#f59e0b', // orange
    actif: true,
  },
  {
    id: 4,
    code: 'VR',
    libelle: 'Véhicule Relavage',
    description: 'Relavage d\'un véhicule',
    dureeEstimee: null, // pas de durée indicative
    couleur: '#06b6d4', // cyan
    actif: true,
  },
  {
    id: 5,
    code: 'POLISH',
    libelle: 'Polish',
    description: 'Polish complet du véhicule',
    dureeEstimee: null, // pas de durée indicative
    couleur: '#8b5cf6', // violet
    actif: true,
  },
  {
    id: 6,
    code: 'AUTRE',
    libelle: 'Autre',
    description: 'Autre type d\'intervention',
    dureeEstimee: null, // pas de durée indicative
    couleur: '#6b7280', // gris
    actif: true,
  },
];

// ============================================
// POINTAGES
// ============================================
export const pointages = [
  // Aujourd'hui
  {
    id: 1,
    technicienId: 2,
    centreId: 1,
    date: new Date().toISOString().split('T')[0],
    heureDebut: '11:00',
    heureFin: null,
    coordonneesGPSDebut: {
      latitude: 48.9356,
      longitude: 2.3539,
    },
    coordonneesGPSFin: null,
    enCours: true,
  },
  {
    id: 2,
    technicienId: 3,
    centreId: 1,
    date: new Date().toISOString().split('T')[0],
    heureDebut: '08:15',
    heureFin: null,
    coordonneesGPSDebut: {
      latitude: 48.9358,
      longitude: 2.3541,
    },
    coordonneesGPSFin: null,
    enCours: true,
  },
  {
    id: 3,
    technicienId: 4,
    centreId: 2,
    date: new Date().toISOString().split('T')[0],
    heureDebut: '08:30',
    heureFin: null,
    coordonneesGPSDebut: {
      latitude: 48.8092,
      longitude: 2.3617,
    },
    coordonneesGPSFin: null,
    enCours: true,
  },
  // Hier
  {
    id: 4,
    technicienId: 2,
    centreId: 1,
    date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heureDebut: '08:00',
    heureFin: '17:00',
    coordonneesGPSDebut: {
      latitude: 48.9356,
      longitude: 2.3539,
    },
    coordonneesGPSFin: {
      latitude: 48.9356,
      longitude: 2.3539,
    },
    enCours: false,
  },
  {
    id: 5,
    technicienId: 3,
    centreId: 1,
    date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heureDebut: '08:15',
    heureFin: '16:45',
    coordonneesGPSDebut: {
      latitude: 48.9358,
      longitude: 2.3541,
    },
    coordonneesGPSFin: {
      latitude: 48.9358,
      longitude: 2.3541,
    },
    enCours: false,
  },
];

// ============================================
// INTERVENTIONS
// ============================================
export const interventions = [
  // Interventions terminées
  {
    id: 1,
    centreId: 1,
    technicienId: 2,
    typeInterventionId: 1,
    plaque: 'AB-123-CD',
    dureeEstimee: 60,
    datePrevu: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heurePrevu: '09:00',
    dateDebut: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heureDebut: '09:05',
    dateFin: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heureFin: '10:10',
    dureeReelle: 65,
    photoAvant: 'photo1-avant.jpg',
    photoApres: 'photo1-apres.jpg',
    commentaire: 'Véhicule en excellent état',
    statut: 'terminee',
    creeLe: new Date(Date.now() - 172800000).toISOString(),
    creePar: 1,
  },
  {
    id: 2,
    centreId: 1,
    technicienId: 2,
    typeInterventionId: 3,
    plaque: 'EF-456-GH',
    dureeEstimee: 45,
    datePrevu: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heurePrevu: '10:30',
    dateDebut: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heureDebut: '10:35',
    dateFin: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    heureFin: '11:15',
    dureeReelle: 40,
    photoAvant: 'photo2-avant.jpg',
    photoApres: 'photo2-apres.jpg',
    commentaire: 'RAS',
    statut: 'terminee',
    creeLe: new Date(Date.now() - 172800000).toISOString(),
    creePar: 1,
  },
  // Intervention en cours
  {
    id: 3,
    centreId: 1,
    technicienId: 2,
    typeInterventionId: 2,
    plaque: 'IJ-789-KL',
    dureeEstimee: 90,
    datePrevu: new Date().toISOString().split('T')[0],
    heurePrevu: '17:00',
    dateDebut: new Date().toISOString().split('T')[0],
    heureDebut: '17:00',
    dateFin: null,
    heureFin: null,
    dureeReelle: null,
    photoAvant: 'photo3-avant.jpg',
    photoApres: null,
    commentaire: null,
    statut: 'en_cours',
    creeLe: new Date(Date.now() - 86400000).toISOString(),
    creePar: 1,
  },
  {
    id: 4,
    centreId: 2,
    technicienId: 4,
    typeInterventionId: 4,
    plaque: 'MN-012-OP',
    dureeEstimee: 120,
    datePrevu: new Date().toISOString().split('T')[0],
    heurePrevu: '17:15',
    dateDebut: new Date().toISOString().split('T')[0],
    heureDebut: '17:15',
    dateFin: null,
    heureFin: null,
    dureeReelle: null,
    photoAvant: 'photo4-avant.jpg',
    photoApres: null,
    commentaire: null,
    statut: 'en_cours',
    creeLe: new Date(Date.now() - 86400000).toISOString(),
    creePar: 1,
  },
  // Interventions planifiées
  {
    id: 5,
    centreId: 1,
    technicienId: 3,
    typeInterventionId: 1,
    plaque: 'QR-345-ST',
    dureeEstimee: 60,
    datePrevu: new Date().toISOString().split('T')[0],
    heurePrevu: '11:00',
    dateDebut: null,
    heureDebut: null,
    dateFin: null,
    heureFin: null,
    dureeReelle: null,
    photoAvant: null,
    photoApres: null,
    commentaire: null,
    statut: 'planifiee',
    creeLe: new Date().toISOString(),
    creePar: 1,
  },
  {
    id: 6,
    centreId: 1,
    technicienId: 2,
    typeInterventionId: 3,
    plaque: 'UV-678-WX',
    dureeEstimee: 45,
    datePrevu: new Date().toISOString().split('T')[0],
    heurePrevu: '14:00',
    dateDebut: null,
    heureDebut: null,
    dateFin: null,
    heureFin: null,
    dureeReelle: null,
    photoAvant: null,
    photoApres: null,
    commentaire: null,
    statut: 'planifiee',
    creeLe: new Date().toISOString(),
    creePar: 1,
  },
  {
    id: 7,
    centreId: 3,
    technicienId: 5,
    typeInterventionId: 5,
    plaque: 'YZ-901-AB',
    dureeEstimee: 180,
    datePrevu: new Date(Date.now() + 86400000).toISOString().split('T')[0],
    heurePrevu: '08:00',
    dateDebut: null,
    heureDebut: null,
    dateFin: null,
    heureFin: null,
    dureeReelle: null,
    photoAvant: null,
    photoApres: null,
    commentaire: 'Client VIP - attention particulière',
    statut: 'planifiee',
    creeLe: new Date().toISOString(),
    creePar: 1,
  },
  {
    id: 8,
    centreId: 1,
    technicienId: 3,
    typeInterventionId: 2,
    plaque: 'CD-234-EF',
    dureeEstimee: 90,
    datePrevu: new Date(Date.now() + 86400000).toISOString().split('T')[0],
    heurePrevu: '09:30',
    dateDebut: null,
    heureDebut: null,
    dateFin: null,
    heureFin: null,
    dureeReelle: null,
    photoAvant: null,
    photoApres: null,
    commentaire: null,
    statut: 'planifiee',
    creeLe: new Date().toISOString(),
    creePar: 1,
  },
];

// ============================================
// CATÉGORIES DE PRODUITS
// ============================================
export const categoriesProduits = [
  { id: 1, nom: 'Savons', description: 'Savons et shampoings', actif: true },
  { id: 2, nom: 'Polish', description: 'Produits de polish et rénovation', actif: true },
  { id: 3, nom: 'Cires', description: 'Cires de protection', actif: true },
  { id: 4, nom: 'Consommables', description: 'Chiffons, éponges, etc.', actif: true },
  { id: 5, nom: 'Accessoires', description: 'Accessoires divers', actif: true },
];

// ============================================
// PRODUITS
// ============================================
export const produits = [
  {
    id: 1,
    nom: 'Shampoing Auto Premium',
    categorieId: 1,
    unite: 'L',
    seuilAlerte: 20,
    description: 'Shampoing concentré haute performance',
    actif: true,
  },
  {
    id: 2,
    nom: 'Polish Rénovateur',
    categorieId: 2,
    unite: 'L',
    seuilAlerte: 10,
    description: 'Polish pour rénovation de carrosserie',
    actif: true,
  },
  {
    id: 3,
    nom: 'Cire de Protection',
    categorieId: 3,
    unite: 'L',
    seuilAlerte: 15,
    description: 'Cire longue durée',
    actif: true,
  },
  {
    id: 4,
    nom: 'Microfibre Premium',
    categorieId: 4,
    unite: 'pièce',
    seuilAlerte: 50,
    description: 'Chiffon microfibre 40x40cm',
    actif: true,
  },
  {
    id: 5,
    nom: 'Éponge de Lavage',
    categorieId: 4,
    unite: 'pièce',
    seuilAlerte: 30,
    description: 'Éponge haute densité',
    actif: true,
  },
  {
    id: 6,
    nom: 'Nettoyant Jantes',
    categorieId: 1,
    unite: 'L',
    seuilAlerte: 15,
    description: 'Nettoyant spécial jantes',
    actif: true,
  },
  {
    id: 7,
    nom: 'Nettoyant Intérieur',
    categorieId: 1,
    unite: 'L',
    seuilAlerte: 10,
    description: 'Nettoyant plastiques et tableaux de bord',
    actif: true,
  },
  {
    id: 8,
    nom: 'Aspirateur HEPA',
    categorieId: 5,
    unite: 'pièce',
    seuilAlerte: 1,
    description: 'Filtre HEPA pour aspirateur',
    actif: true,
  },
];

// ============================================
// STOCKS PAR CENTRE
// ============================================
export const stocks = [
  // Centre 1 - Paris Nord
  { id: 1, centreId: 1, produitId: 1, quantite: 45, derniereMAJ: new Date().toISOString(), modifiePar: 2 },
  { id: 2, centreId: 1, produitId: 2, quantite: 8, derniereMAJ: new Date().toISOString(), modifiePar: 2 }, // Alerte
  { id: 3, centreId: 1, produitId: 3, quantite: 25, derniereMAJ: new Date().toISOString(), modifiePar: 2 },
  { id: 4, centreId: 1, produitId: 4, quantite: 120, derniereMAJ: new Date().toISOString(), modifiePar: 3 },
  { id: 5, centreId: 1, produitId: 5, quantite: 45, derniereMAJ: new Date().toISOString(), modifiePar: 3 },
  { id: 6, centreId: 1, produitId: 6, quantite: 18, derniereMAJ: new Date().toISOString(), modifiePar: 2 },
  { id: 7, centreId: 1, produitId: 7, quantite: 12, derniereMAJ: new Date().toISOString(), modifiePar: 2 },
  { id: 8, centreId: 1, produitId: 8, quantite: 3, derniereMAJ: new Date().toISOString(), modifiePar: 2 },
  
  // Centre 2 - Paris Sud
  { id: 9, centreId: 2, produitId: 1, quantite: 35, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 10, centreId: 2, produitId: 2, quantite: 15, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 11, centreId: 2, produitId: 3, quantite: 20, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 12, centreId: 2, produitId: 4, quantite: 95, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 13, centreId: 2, produitId: 5, quantite: 40, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 14, centreId: 2, produitId: 6, quantite: 22, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 15, centreId: 2, produitId: 7, quantite: 14, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  { id: 16, centreId: 2, produitId: 8, quantite: 2, derniereMAJ: new Date().toISOString(), modifiePar: 4 },
  
  // Centre 3 - Nanterre
  { id: 17, centreId: 3, produitId: 1, quantite: 15, derniereMAJ: new Date().toISOString(), modifiePar: 5 }, // Alerte
  { id: 18, centreId: 3, produitId: 2, quantite: 12, derniereMAJ: new Date().toISOString(), modifiePar: 5 },
  { id: 19, centreId: 3, produitId: 3, quantite: 18, derniereMAJ: new Date().toISOString(), modifiePar: 5 },
  { id: 20, centreId: 3, produitId: 4, quantite: 80, derniereMAJ: new Date().toISOString(), modifiePar: 5 },
  { id: 21, centreId: 3, produitId: 5, quantite: 25, derniereMAJ: new Date().toISOString(), modifiePar: 5 }, // Alerte
  { id: 22, centreId: 3, produitId: 6, quantite: 16, derniereMAJ: new Date().toISOString(), modifiePar: 5 },
  { id: 23, centreId: 3, produitId: 7, quantite: 9, derniereMAJ: new Date().toISOString(), modifiePar: 5 }, // Alerte
  { id: 24, centreId: 3, produitId: 8, quantite: 1, derniereMAJ: new Date().toISOString(), modifiePar: 5 },
  
  // Centre 4 - Créteil
  { id: 25, centreId: 4, produitId: 1, quantite: 50, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 26, centreId: 4, produitId: 2, quantite: 18, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 27, centreId: 4, produitId: 3, quantite: 28, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 28, centreId: 4, produitId: 4, quantite: 110, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 29, centreId: 4, produitId: 5, quantite: 55, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 30, centreId: 4, produitId: 6, quantite: 20, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 31, centreId: 4, produitId: 7, quantite: 15, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  { id: 32, centreId: 4, produitId: 8, quantite: 2, derniereMAJ: new Date().toISOString(), modifiePar: 6 },
  
  // Centre 5 - Versailles
  { id: 33, centreId: 5, produitId: 1, quantite: 40, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 34, centreId: 5, produitId: 2, quantite: 14, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 35, centreId: 5, produitId: 3, quantite: 22, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 36, centreId: 5, produitId: 4, quantite: 100, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 37, centreId: 5, produitId: 5, quantite: 50, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 38, centreId: 5, produitId: 6, quantite: 19, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 39, centreId: 5, produitId: 7, quantite: 11, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
  { id: 40, centreId: 5, produitId: 8, quantite: 2, derniereMAJ: new Date().toISOString(), modifiePar: 7 },
];

// ============================================
// FONCTIONS UTILITAIRES
// ============================================

// Obtenir un utilisateur par son ID
export const getUserById = (id) => {
  return users.find(u => u.id === id);
};

// Obtenir un centre par son ID
export const getCentreById = (id) => {
  return centres.find(c => c.id === id);
};

// Obtenir les techniciens d'un centre
export const getTechniciensByCentre = (centreId) => {
  return users.filter(u => u.role === 'technicien' && u.centreId === centreId);
};

// Obtenir tous les techniciens
export const getTechniciens = () => {
  return users.filter(u => u.role === 'technicien');
};

// Obtenir un type d'intervention par ID
export const getTypeInterventionById = (id) => {
  return typesIntervention.find(t => t.id === id);
};

// Obtenir les interventions d'un technicien
export const getInterventionsByTechnicien = (technicienId, date = null) => {
  let result = interventions.filter(i => i.technicienId === technicienId);
  if (date) {
    result = result.filter(i => i.datePrevu === date);
  }
  return result;
};

// Obtenir les interventions d'un centre
export const getInterventionsByCentre = (centreId, date = null) => {
  let result = interventions.filter(i => i.centreId === centreId);
  if (date) {
    result = result.filter(i => i.datePrevu === date);
  }
  return result;
};

// Obtenir les interventions en cours
export const getInterventionsEnCours = () => {
  return interventions.filter(i => i.statut === 'en_cours');
};

// Obtenir le pointage en cours d'un technicien
export const getPointageEnCours = (technicienId) => {
  return pointages.find(p => p.technicienId === technicienId && p.enCours === true);
};

// Obtenir les pointages d'un technicien pour une période
export const getPointagesByTechnicien = (technicienId, dateDebut, dateFin) => {
  return pointages.filter(p => 
    p.technicienId === technicienId && 
    p.date >= dateDebut && 
    p.date <= dateFin
  );
};

// Calculer le temps total travaillé
export const calculerTempsTravaille = (pointagesListe) => {
  let totalMinutes = 0;
  pointagesListe.forEach(p => {
    if (p.heureDebut && p.heureFin) {
      const [hd, md] = p.heureDebut.split(':').map(Number);
      const [hf, mf] = p.heureFin.split(':').map(Number);
      const minutes = (hf * 60 + mf) - (hd * 60 + md);
      totalMinutes += minutes;
    }
  });
  return totalMinutes;
};

// Obtenir un produit par ID
export const getProduitById = (id) => {
  return produits.find(p => p.id === id);
};

// Obtenir une catégorie par ID
export const getCategorieById = (id) => {
  return categoriesProduits.find(c => c.id === id);
};

// Obtenir le stock d'un produit dans un centre
export const getStock = (centreId, produitId) => {
  return stocks.find(s => s.centreId === centreId && s.produitId === produitId);
};

// Obtenir tous les stocks d'un centre
export const getStocksByCentre = (centreId) => {
  return stocks.filter(s => s.centreId === centreId);
};

// Vérifier si un produit est en alerte dans un centre
export const isStockEnAlerte = (centreId, produitId) => {
  const stock = getStock(centreId, produitId);
  const produit = getProduitById(produitId);
  if (!stock || !produit) return false;
  return stock.quantite <= produit.seuilAlerte;
};

// Obtenir tous les stocks en alerte
export const getStocksEnAlerte = () => {
  return stocks.filter(s => {
    const produit = getProduitById(s.produitId);
    return produit && s.quantite <= produit.seuilAlerte;
  });
};

// Calculer les statistiques d'un technicien pour une période
export const getStatistiquesTechnicien = (technicienId, dateDebut, dateFin) => {
  const interventionsPeriode = interventions.filter(i => 
    i.technicienId === technicienId && 
    i.dateDebut >= dateDebut && 
    i.dateDebut <= dateFin &&
    i.statut === 'terminee'
  );

  const nombreInterventions = interventionsPeriode.length;
  
  // Temps moyen par intervention
  const tempsMoyenIntervention = nombreInterventions > 0
    ? interventionsPeriode.reduce((sum, i) => sum + (i.dureeReelle || 0), 0) / nombreInterventions
    : 0;

  // Temps moyen par type
  const tempsParType = {};
  const nombreParType = {};
  
  interventionsPeriode.forEach(i => {
    const type = getTypeInterventionById(i.typeInterventionId);
    if (type) {
      if (!tempsParType[type.code]) {
        tempsParType[type.code] = 0;
        nombreParType[type.code] = 0;
      }
      tempsParType[type.code] += i.dureeReelle || 0;
      nombreParType[type.code]++;
    }
  });

  Object.keys(tempsParType).forEach(code => {
    tempsParType[code] = tempsParType[code] / nombreParType[code];
  });

  // Temps total travaillé
  const pointagesPeriode = getPointagesByTechnicien(technicienId, dateDebut, dateFin);
  const tempsTotalTravaille = calculerTempsTravaille(pointagesPeriode);

  return {
    nombreInterventions,
    tempsMoyenIntervention,
    tempsParType,
    nombreParType,
    tempsTotalTravaille,
  };
};

// Calculer les statistiques globales pour une période
export const getStatistiquesGlobales = (dateDebut, dateFin) => {
  const interventionsPeriode = interventions.filter(i => 
    i.dateDebut >= dateDebut && 
    i.dateDebut <= dateFin &&
    i.statut === 'terminee'
  );

  // Nombre total d'interventions par centre
  const interventionsParCentre = {};
  centres.forEach(c => {
    interventionsParCentre[c.id] = interventionsPeriode.filter(i => i.centreId === c.id).length;
  });

  // Répartition par type d'intervention
  const repartitionParType = {};
  typesIntervention.forEach(t => {
    repartitionParType[t.code] = interventionsPeriode.filter(i => i.typeInterventionId === t.id).length;
  });

  return {
    nombreTotal: interventionsPeriode.length,
    interventionsParCentre,
    repartitionParType,
  };
};
